// client/src/theme.js

/**
 * Colour theme for the three kinds of borrower information.
 *
 * This lives in its own module rather than in Stage.jsx because Stage.jsx imports
 * the components that need it (FeaturePlots, VariableIntroduction) while those
 * components need the theme back -- a circular import. It happened to work, since
 * the theme is only read at render time, but it is fragile: any change that makes
 * one of them read the theme during module evaluation would break with an
 * undefined value at load. A leaf module breaks the cycle.
 */

export const variable_theme = {
  public: {
    color: '#0f766e',    // Teal-700: Analytical and "foundational"
    textColor: 'text-teal-800',
    borderColor: 'border-teal-300',
    bgColor: 'bg-teal-50/40',
    label: 'Public Information'
  },
  private: {
    // Shifted from Teal to a cool Navy/Royal Blue to remove green undertones
    color: '#1d4ed8',    // Blue-700: High contrast, clearly distinct from green
    textColor: 'text-blue-900',
    borderColor: 'border-blue-400',
    bgColor: 'bg-blue-50/50',
    label: 'User-Specific Info'
  },
  ai: {
    // Shifted from Indigo to a distinct Plum/Violet to separate from Blue
    color: '#7e22ce',    // Violet-700: Clearly distinct from Blue/Teal/Green/Red
    textColor: 'text-purple-900',
    borderColor: 'border-purple-400',
    bgColor: 'bg-purple-50/50',
    label: 'AI Recommendation'
  }
};
